import { AxiosError, default as axiosClass } from "axios";

export const isInvalidAuthenticityToken = (error: AxiosError | Error) =>
  axiosClass.isAxiosError(error) &&
  error.response?.status === 422 &&
  typeof error.response?.data === "string" &&
  error.response.data.includes("ActionController::InvalidAuthenticityToken");
